import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import API from "../../lib/api";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { err, fmt } from "./mpUtils";
import { Storefront } from "@phosphor-icons/react";

/** On a supplier record: one-click invite to list on the marketplace, or a badge if they're already there. */
export function SupplierMarketplaceInvite({ supplierId }) {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => API.get(`/suppliers/${supplierId}/marketplace-status`).then((r) => setSt(r.data)).catch(() => setSt(null)), [supplierId]);
  useEffect(() => { load(); }, [load]);
  if (!st) return null;
  if (st.listed) {
    return (
      <Badge className="text-[10px] bg-primary/10 text-primary gap-1" data-testid="supplier-marketplace-listed">
        <Storefront size={12} weight="fill" /> {st.contractor?.live ? <Link to={`/marketplace/contractors/${st.contractor.id}`} className="hover:underline">On the Marketplace</Link> : "Marketplace listing pending"}
      </Badge>
    );
  }
  const invite = async () => {
    setBusy(true);
    try { const { data } = await API.post(`/suppliers/${supplierId}/marketplace-invite`, { origin_url: window.location.origin }); toast.success(data.message); load(); } catch (e) { err(e, "Couldn't send the invite"); } finally { setBusy(false); }
  };
  const sent = st.invite?.status === "sent";
  return (
    <Button variant="outline" size="sm" onClick={invite} disabled={busy || !st.can_invite} title={!st.can_invite ? "Add an e-mail address to the supplier first" : sent ? `Invited ${fmt(st.invite.sent_at)} — send again` : "E-mail them a link to create their marketplace listing"} data-testid="supplier-marketplace-invite-btn">
      <Storefront size={14} className="mr-1" /> {busy ? "Sending…" : sent ? `Marketplace invite sent ${fmt(st.invite.sent_at)} · resend` : "Invite to Marketplace"}
    </Button>
  );
}
